import { useBlockEditContext } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import PanelSettings from './advance/inspector-control';
import AdvanceSettings from './advance';
import Slider from './swiperSettings'; 
import { useEffect } from 'react';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { MouseFollower } from '@vayu-blocks';
import clsx from 'clsx';

export default function Edit(props) {

	const { attributes, setAttributes,isSelected,isSelectionEnabled }  = props;
	const { clientId } = useBlockEditContext();
	const getView = VayuBlocksDevice();

    useEffect(() => {
        setAttributes({ uniqueId: `vb-${clientId.substring(0, 8)}` });
    }, [clientId]);

	useEffect(() => {
		setAttributes({ viewslider: getView });
	}, [getView]);

	const wrapperClass = clsx(`vb-slider-start vb-slider-wrapper-div-${attributes.uniqueId}`, {
		[`align${attributes.align}`]: attributes.align,
	});


	return (
		<div className={wrapperClass}>
  			<PanelSettings attributes={attributes} setAttributes={setAttributes} isSelected={isSelected} clientId={clientId}/>
  			<AdvanceSettings attributes={attributes} setAttributes={setAttributes} clientId={clientId}>
			
					<Slider
						clientId={ clientId }
						attributes={ attributes }
						setAttributes={setAttributes}
						isSelected ={isSelected}
						isSelectionEnabled= {isSelectionEnabled} 
					/>
			
				<MouseFollower value={attributes.advFollower} clientId={clientId}/>
			</AdvanceSettings>
		</div>
	);
}